// Import model
import { FilterReportDocumentTemplateRequest } from '../models/FilterReportDocumentTemplateRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ReportDocumentTemplateCondition } from '../models/ReportDocumentTemplateCondition';
import { ReportDocumentTemplateFields } from '../models/ReportDocumentTemplateFields';
import { ReportDocumentTemplateIndexedFields } from '../models/ReportDocumentTemplateIndexedFields';

// Import dependency serializers (for complex types)
import { ReportDocumentTemplateConditionSerializer } from './ReportDocumentTemplateConditionSerializer';
import { ReportDocumentTemplateFieldsSerializer } from './ReportDocumentTemplateFieldsSerializer';
import { ReportDocumentTemplateIndexedFieldsSerializer } from './ReportDocumentTemplateIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterReportDocumentTemplateRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterReportDocumentTemplateRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterReportDocumentTemplateRequest instance
   */
  static deserialize(json: string): FilterReportDocumentTemplateRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterReportDocumentTemplateRequest instance
   */
  static fromObject(obj: any): FilterReportDocumentTemplateRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterReportDocumentTemplateRequest');
    }


    const instance: FilterReportDocumentTemplateRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ReportDocumentTemplateIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ReportDocumentTemplateFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ReportDocumentTemplateConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterReportDocumentTemplateRequest instances
   */
  static deserializeArray(json: string): FilterReportDocumentTemplateRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterReportDocumentTemplateRequest instance to a JSON string
   */
  static serialize(instance: FilterReportDocumentTemplateRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterReportDocumentTemplateRequest instance to a plain object
   */
  static toObject(instance: FilterReportDocumentTemplateRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ReportDocumentTemplateConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterReportDocumentTemplateRequest instances to a JSON string
   */
  static serializeArray(instances: FilterReportDocumentTemplateRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
